import { render, staticRenderFns } from "./license.vue?vue&type=template&id=5b06d705&"
import script from "./license.vue?vue&type=script&lang=js&"
export * from "./license.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports